module.exports = __webpack_public_path__ + "img/user-group_ar.1c7d3d34.png";